"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloExtensionsClient = void 0;
var ApolloExtensionsClient_1 = require("./ApolloExtensionsClient");
Object.defineProperty(exports, "ApolloExtensionsClient", { enumerable: true, get: function () { return __importDefault(ApolloExtensionsClient_1).default; } });
//# sourceMappingURL=index.js.map